// Một vòng requestAnimationFrame dùng chung cho mọi hiệu ứng theo mùa trên trang.
// Vòng lặp chỉ chạy khi có ít nhất một bên đăng ký; trình duyệt tự dừng rAF khi tab ẩn.

type Ticker = (dt: number, seconds: number) => void

const tickers = new Set<Ticker>()
let raf = 0
let last = 0

function frame(ts: number) {
  raf = tickers.size ? requestAnimationFrame(frame) : 0
  const dt = last ? Math.min(0.05, (ts - last) / 1000) : 0
  last = ts
  for (const f of tickers) f(dt, ts / 1000)
}

export function addTicker(fn: Ticker): () => void {
  tickers.add(fn)
  if (!raf) {
    last = 0
    raf = requestAnimationFrame(frame)
  }
  return () => {
    tickers.delete(fn)
    if (!tickers.size && raf) {
      cancelAnimationFrame(raf)
      raf = 0
    }
  }
}
